import consumer from "./consumer"

// Subscriber for the /invoices/status board. Receives invoice-job results on the
// global "invoice_status_updates" stream and hands them to the page's
// window.handleInvoiceResult, which swaps the affected card in place.
//
// Message shape: { type: "invoice_result", guid, po, status: "invoiced"|"error", message }

function handleInvoiceStatusLoad() {
  if (!document.querySelector('.invoice-status-page')) return;

  if (window.invoiceStatusSubscription) {
    window.invoiceStatusSubscription.unsubscribe();
    window.invoiceStatusSubscription = null;
  }

  window.invoiceStatusSubscription = consumer.subscriptions.create("InvoiceStatusChannel", {
    received(data) {
      if (!data || data.type !== 'invoice_result') return;
      if (typeof window.handleInvoiceResult === 'function') {
        try { window.handleInvoiceResult(data); } catch (e) { console.error('InvoiceStatusChannel handler error', e, data); }
      }
    }
  });
}

function handleInvoiceStatusBeforeCache() {
  if (window.invoiceStatusSubscription) {
    window.invoiceStatusSubscription.unsubscribe();
    window.invoiceStatusSubscription = null;
  }
}

// Dedupe across module re-evaluations so handlers don't stack on repeat navs.
if (window._invoiceStatusLoadHandler) {
  document.removeEventListener('turbolinks:load', window._invoiceStatusLoadHandler);
}
if (window._invoiceStatusBeforeCacheHandler) {
  document.removeEventListener('turbolinks:before-cache', window._invoiceStatusBeforeCacheHandler);
}
window._invoiceStatusLoadHandler = handleInvoiceStatusLoad;
window._invoiceStatusBeforeCacheHandler = handleInvoiceStatusBeforeCache;
document.addEventListener('turbolinks:load', window._invoiceStatusLoadHandler);
document.addEventListener('turbolinks:before-cache', window._invoiceStatusBeforeCacheHandler);
